import { ActionReducerMap } from '@ngrx/store';
import { filterUsersReducers } from '../../../core/store/reducers/filter-users.reducers';
import { calendarsReducers } from './calendars.reducers';
import { pendingChangesReducer } from 'app/core/store/reducers/pending-changes.reducers';


export const WORKING_TIME_SCHEMA_REDUCER: ActionReducerMap<IWorkingTimeSchemaState> = {
    filterUsersState: filterUsersReducers,
    calendarState: calendarsReducers,
    pendingChangesWorkingTimeSchema: pendingChangesReducer
};